const createStyleNode = (scope, cssText) => {
    const styleElement = scope.document.createElement('style');
    styleElement.setAttribute('type', 'text/css');
    if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = cssText;
    } else {
        styleElement.appendChild(scope.document.createTextNode(cssText));
    }
    return styleElement;
};

function isObject(item) {
    return (item && 'object' === typeof item && !Array.isArray(item));
}

function mergeDeep(target, ...sources) {
    if (!sources.length) {
        return target
    }

    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, {[key]: {}})
                }
                mergeDeep(target[key], source[key]);
            } else {
                Object.assign(target, {[key]: source[key]});
            }
        }
    }

    return mergeDeep(target, ...sources);
}

const merge = function (...toMerge) {
    if (0 === toMerge.length) {
        throw '[FPVA] Empty merge subject';
    }

    for (const subject of toMerge) {
        if (!isObject(subject)) {
            throw '[FPVA] Invalid merge subject';
        }
    }
    return mergeDeep({}, ...toMerge);
};

const objectToQueryString = function (obj) {
    return '?' + Object.keys(obj).reduce(function (a, k) {
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
    }, []).join('&');
};

export {createStyleNode, merge, objectToQueryString};
